import React, {useEffect} from "react";
import {Form, Select} from "antd";

import InputWrap from "../../InputWrap";
import SensorScalingFields from "./SensorScalingFields";
import {SensorSettings, SettingsSensor, Unit} from "../../../store/branches/sensors/stateTypes";

import classes from "../EditSensorsTypes.module.scss";


interface Device0005Props {
    sensorSettings: SensorSettings
    units?: Unit[]
    form: any
    deviceType: string
}

interface sensorTypeI {
    type: string
    value: string
}

const {Option} = Select;

const DeviceSettingsForm: React.FC<Device0005Props> = ({
                                                           sensorSettings,
                                                           units,
                                                           form,
                                                           deviceType,
                                                       }) => {
    const sensorType: sensorTypeI[] = [
        {type: "BOOL", value: "Digital"},
        {type: "NUMERIC", value: "Analog"},
    ];

    const currentName = (index?: number, name?: string) => {
        if (deviceType === "0006") {
            return `CLI ${index + 1}`;
        }
        return `${name} ${index + 1}`;
    };

    useEffect(() => {
        form.setFieldsValue(sensorSettings);
    }, [sensorSettings, form]);


    return (
        <React.Fragment>
            <div className={classes.driver}>
                <span>{sensorSettings.name}</span>
                <div className={classes.cssBaseLine}/>
            </div>

            <div className={classes.blocksWrap}>
                {
                    sensorSettings?.sensors?.map((sensor: SettingsSensor, index: number) => {
                        return <div className={classes.sideBlock} key={`wrap_device_map${sensor.id}${index}`}>

                            <InputWrap title={`${currentName(index, sensorSettings.name)}`}
                                       className={classes.wideInput}
                                       key={`pulse_1_${sensor?.type}${index}`}>
                                <Form.Item name={`${sensor.id} type`}
                                           initialValue={sensor?.type === "BOOL" ? "Digital" : "Analog"}
                                >
                                    <Select>
                                        {
                                            sensorType?.map((item: sensorTypeI, index: number) => (
                                                <Option value={item?.type}
                                                        key={`option_unit${item?.type}_${item?.value}${index}`}>{item?.value}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            </InputWrap>

                            <SensorScalingFields sensor={sensor}
                                                 units={units}
                                                 form={form}
                                                 titlePrefix={currentName(index, sensorSettings.name)}/>
                        </div>;
                    })
                }
            </div>
        </React.Fragment>
    );
};

export default DeviceSettingsForm;
